import { SettingsResponse, Setting, SettingResponse } from "../coworkerApiCalls/Setting/SettingsTypes";

const settingResponseToSetting = (setting: SettingResponse): Setting => {
  return {
    id: setting.id,
    name: setting.name,
    value: setting.value,
  };
};

const settingResponsesToSettings = (settings: SettingsResponse): Setting[] => {
  return settings.map((setting: SettingResponse): Setting => settingResponseToSetting(setting));
};

export { settingResponseToSetting, settingResponsesToSettings };